(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    // ----- Accordion: all accordions can be open independently on mobile -----
    var accordions = document.querySelectorAll('.md-accordion details');

    // Remove any toggle restriction - allow all accordions to open/close independently
    // accordions.forEach(function (item) {
    //   item.removeEventListener('toggle', toggleHandler);
    // });

    // Ensure desktop behavior: all accordions open by default on desktop
    function handleDesktopAccordion() {
      var allDetails = document.querySelectorAll('.md-accordion details');
      if (window.innerWidth >= 1024) {
        allDetails.forEach(function (d) {
          d.open = true;
        });
      }
    }

    // Initial setup
    handleDesktopAccordion();

    // Handle resize for desktop
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        handleDesktopAccordion();
      }, 250);
    });

    // ----- Newsletter: auto-hide success after 6 seconds -----
    var successEl = document.getElementById('newsletter-success');
    var formWrapper = document.getElementById('newsletter-form-wrapper');
    var form = document.getElementById('newsletter-form');

    if (successEl && formWrapper) {
      // Show success message, hide form wrapper
      successEl.style.display = 'flex';
      formWrapper.style.display = 'none';

      // Auto-hide success after 6 seconds and show form
      setTimeout(function () {
        successEl.style.display = 'none';
        formWrapper.style.display = 'block';

        // Reset the form to allow resubmission
        if (form) {
          // Remove the success state from URL params by replacing the form action
          // This prevents the success message from showing again on refresh
          var currentUrl = window.location.href;
          if (currentUrl.indexOf('?') !== -1) {
            var cleanUrl = currentUrl.split('?')[0];
            window.history.replaceState({}, document.title, cleanUrl);
          }
        }
      }, 6000); // 6 seconds
    }

    // ----- Badge animation (intersection) -----
    var badges = document.querySelectorAll('.md-badge');
    if (badges.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('show');
            }
          });
        },
        { threshold: 0.15 }
      );
      badges.forEach(function (b) {
        observer.observe(b);
      });
    } else {
      badges.forEach(function (b) {
        b.classList.add('show');
      });
    }

    // ----- Benefit hover (desktop) -----
    document.querySelectorAll('.md-benefit').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        el.style.transform = 'translateX(5px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = '';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
